<template>
  <div class="page-container">
    <!-- Bütün sayfayı kaplayan loading ekranı -->
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p>Yükleniyor...</p>
    </div>

    <div class="row" v-show="!loading">
      <div class="container">
        <vue-good-table
            ref="productTable"
            mode="remote"
            :key="tableKey"
            @on-column-filter="onColumnFilter($event.columnFilters)"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChange"
            :rows="rows"
            :columns="columns"
            :totalRows="totalRecords"
            :line-numbers="true"
            :pagination-options="{
              enabled: true,
              perPage: serverParams.perPage,
              perPageDropdown: [5, 10, 20, 50],
              dropdownAllowAll: false,
              mode: 'records',
              nextLabel: 'Sonraki',
              prevLabel: 'Önceki',
              rowsPerPageLabel: 'Sayfa başına satır',
              ofLabel: '/',
              pageLabel: 'sayfa',
              allLabel: 'Tümü',
              initialPage: serverParams.page
            }"
        >
          <div slot="table-actions" class="d-flex gap-2">
            <b-button
                variant="success"
                v-on:click.prevent="downloadProductCatalog"
                :disabled="loading"
            >
              <b-spinner v-if="loading" small></b-spinner>
              <span v-else>Ürün Kataloğu İndir</span>
            </b-button>
            <b-button
                type="submit"
                variant="primary"
                v-on:click.prevent="updateProducts"
                :disabled="loading"
            >
              <b-spinner v-if="loading" small></b-spinner>
              <span v-else>Ürünleri Güncelle</span>
            </b-button>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'iconUrl' && props.formattedRow.iconUrl">
              <img
                  :src="props.formattedRow.iconUrl"
                  alt="Ürün Görseli"
                  width="40"
                  height="40"
                  class="rounded shadow-sm cursor-pointer"
                  style="object-fit: cover"
                  @click="openImageModal(props.formattedRow.url)"
              />
            </span>
            <span v-else-if="props.column.field === 'actions'">
              <div class="d-flex justify-content-center gap-2 px-2">
                <b-button variant="success" v-on:click.prevent="updateRecord(props.formattedRow)">Güncelle</b-button>
                <b-button variant="danger" @click.prevent="deleteProducts(props.formattedRow.id)">Sil</b-button>
              </div>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
    <b-modal id="image-modal" size="lg" hide-footer title="Ürün Görseli" v-model="showImageModal">
      <img :src="selectedImageUrl" class="img-fluid" />
    </b-modal>
  </div>
</template>

<script>
import ProductService from "@/service/ProductService";
import * as XLSX from "xlsx";
const LOCAL_STORAGE_KEY_ADMIN_PRODUCT_LIST_FILTERS = 'adminProductListFilters';
const LOCAL_STORAGE_KEY_ADMIN_PRODUCT_LIST_SCROLL = 'adminProductListScroll';
const SESSION_STORAGE_KEY_PRODUCT_GOING_TO_UPDATE = 'goingToProductUpdate';
export default {
  name: 'product-filter-list',
  data() {
    return {
      totalRecords: 0,
      loading: false,  // ✅ Sayfa yükleniyor mu?
      showImageModal: false,
      selectedImageUrl: null,
      columns: [
        {
          field: 'id',
          hidden: true
        },
        {
          label: 'Görsel',
          field: 'iconUrl',
          sortable: false,
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          field: 'url',
          sortable: false,
          hidden: true
        },
        {
          label: 'Ürün Adı',
          field: 'name',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Ürün Adına Göre Filtrele',
            trigger: 'enter',
          }
        },
        {
          label: 'Alış Fiyatı',
          field: 'buyingPriceText',
          sortable: false,
          tdClass: 'text-right text-nowrap'
        },
        {
          hidden: true,
          field: 'buyingPrice'
        },
        {
          label: 'Satış Fiyatı',
          field: 'listPriceText',
          sortable: false,
          tdClass: 'text-right text-nowrap'
        },
        {
          hidden: true,
          field: 'listPrice'
        },
        {
          hidden: true,
          field: 'vatRate'
        },
        {
          hidden: true,
          field: 'productOptions'
        },
        {
          hidden: true,
          field: 'shopVisibilityList'
        },
        {
          label: 'Birim',
          field: 'unit',
          sortable: false,
        },
        {
          hidden: true,
          field: 'type'
        },
        {
          field: 'actions',
          sortable: false,
        }
      ],
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 10
      },
      rows: [],
      tableKey: 0,
    };
  },
  watch: {
    serverParams: {
      handler(newVal) {
        localStorage.setItem(
            LOCAL_STORAGE_KEY_ADMIN_PRODUCT_LIST_FILTERS,
            JSON.stringify(newVal)
        );
      },
      deep: true
    }
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems(this.serverParams);
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems(this.serverParams);
    },

    onColumnFilter(params) {
      this.updateParams({ columnFilters: params });
      this.loadItems(this.serverParams);
    },

    async loadItems(params) {
      this.loading = true;
      try {
        const response = await ProductService.getAdminList(params);
        this.rows = response.data;
        this.totalRecords = response.total;
      } catch (error) {
        console.error("Listeleme sırasında hata oluştu:", error);
      } finally {
        this.loading = false;
      }
    },

    async updateProducts() {
      this.loading = true;  // ✅ Sayfa yükleniyor
      try {
        await ProductService.fetch();
        await this.loadItems(this.serverParams);  // Güncellemeden sonra listeyi yenile
        this.$notification(this, "Ürünler başarıyla güncellendi.");
      } catch (error) {
        console.error("Ürünler güncellenirken hata oluştu:", error);
        this.$errorNotification(this, "Ürünler güncellenirken hata oluştu.");
      } finally {
        this.loading = false; // ✅ İşlem bittiğinde kaldır
      }
    },

    async deleteProducts(id) {
      this.loading = true;  // ✅ Sayfa yükleniyor
      try {
        await ProductService.deleteProduct(id);
        await this.loadItems(this.serverParams);  // Güncellemeden sonra listeyi yenile
        this.$notification(this, "Ürün başarıyla silindi.");
      } catch (error) {
        console.error("Ürün silinirken hata oluştu:", error);
        this.$errorNotification(this, "Ürün silinirken hata oluştu.");
      } finally {
        this.loading = false; // ✅ İşlem bittiğinde kaldır
      }
    },

    updateRecord(params) {
      sessionStorage.setItem(SESSION_STORAGE_KEY_PRODUCT_GOING_TO_UPDATE, 'true');
      this.$router.push({ name: 'AdminProductUpdate', params : params });
    },

    async downloadProductCatalog() {
      this.loading = true;
      try {
        const products = await ProductService.getCatalogList();

        if (!products || !products.length) {
          this.$bvToast?.toast("Kayıt bulunamadı.", { variant: "warning" });
          return;
        }

        const formatPrice = (value) => {
          if (value == null) return '';
          return '₺' + Number(value).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        const aoa = [
          ["Ürün Adı", "Satış Fiyatı"],
          ...products.map(p => [p.name, formatPrice(p.buyingPrice)])
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(aoa);

        // Her kolon için içeriğe göre otomatik genişlik hesapla
        const colCount = aoa[0].length;
        worksheet['!cols'] = Array.from({ length: colCount }, (_, colIdx) => {
          const maxLen = aoa.reduce((max, row) => {
            const len = Array.from(String(row[colIdx] ?? '')).length;
            return len > max ? len : max;
          }, 0);
          return { wch: Math.max(10, Math.min(60, maxLen + 2)) };
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Ürün Kataloğu");
        XLSX.writeFile(workbook, "urun_katalogu.xlsx");
      } catch (error) {
        console.error("Ürün kataloğu indirilirken hata oluştu:", error);
        this.$errorNotification(this, "Ürün kataloğu indirilirken hata oluştu.");
      } finally {
        this.loading = false;
      }
    },

    openImageModal(imageUrl) {
      if (!imageUrl) {
        return
      }
      this.selectedImageUrl = imageUrl;
      this.showImageModal = true;
    }
  },
  beforeRouteLeave(to, from, next) {
    const fromUpdate = sessionStorage.getItem(SESSION_STORAGE_KEY_PRODUCT_GOING_TO_UPDATE) === 'true';

    if (fromUpdate) {
      localStorage.setItem(
          LOCAL_STORAGE_KEY_ADMIN_PRODUCT_LIST_SCROLL,
          window.scrollY.toString()
      );

      localStorage.setItem(
          LOCAL_STORAGE_KEY_ADMIN_PRODUCT_LIST_FILTERS,
          JSON.stringify(this.serverParams)
      );
    } else {
      localStorage.removeItem(LOCAL_STORAGE_KEY_ADMIN_PRODUCT_LIST_SCROLL);
      localStorage.removeItem(LOCAL_STORAGE_KEY_ADMIN_PRODUCT_LIST_FILTERS);
    }

    next();
  },
  async mounted() {
    const fromUpdate = sessionStorage.getItem(SESSION_STORAGE_KEY_PRODUCT_GOING_TO_UPDATE) === 'true';

    if (fromUpdate) {
      const saved = localStorage.getItem(LOCAL_STORAGE_KEY_ADMIN_PRODUCT_LIST_FILTERS);
      if (saved) {
        try {
          this.serverParams = JSON.parse(saved);

          // Vue-good-table yeniden render edilsin ki initialPage dikkate alınsın
          this.tableKey++;
        } catch (e) {
          console.warn('serverParams verisi bozuk:', e);
        }
      }
    }
    await this.loadItems(this.serverParams);
    if (fromUpdate) {
      this.$nextTick(() => {
        setTimeout(() => {
          const scroll = localStorage.getItem(LOCAL_STORAGE_KEY_ADMIN_PRODUCT_LIST_SCROLL);
          if (scroll) {
            window.scrollTo(0, parseInt(scroll));
          }

          sessionStorage.removeItem(SESSION_STORAGE_KEY_PRODUCT_GOING_TO_UPDATE);
        }, 100);
      });
    }
  }
};
</script>

<style>
/* Sayfanın üstüne loading efekti ekleyen CSS */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Yarı saydam beyaz */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 1000;
  font-size: 20px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
